import { render, staticRenderFns } from "./tb_rev_overview.vue?vue&type=template&id=0b25dba8&scoped=true"
import script from "./tb_rev_overview.vue?vue&type=script&lang=js"
export * from "./tb_rev_overview.vue?vue&type=script&lang=js"
import style0 from "./tb_rev_overview.vue?vue&type=style&index=0&id=0b25dba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25dba8",
  null
  
)

export default component.exports